import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
  FormControl,
  Tabs,
  Tab,
  Paper,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TextareaAutosize, makeStyles } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import { getKraDataList, insertKraData } from "../../../../api/KRAapis";
import { handleAxiosError } from "../../../../config/action-config";
import TabPanel from "../../../../component/TabPanel";
import AgGridTable from "../../../../component/AgGridTable";
import { showAlert } from "../../../../actions/alert";
import { KRATable as tableDef } from "../../../../config/grid-columns-defs";
import CustomLargeTextCellEditor from "../../../../component/CustomLargeCellEditor";

const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));
export default function KraList() {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const classes = useStyles();
  const location = useLocation();
  const [goal, setGoal] = useState("");
  const [department, setDepartment] = useState("");
  const [year, setYear] = useState("");
  const [role, setRole] = useState("");
  const [kpiData, setKpiData] = useState([]);
  const [employeeName, setEmployeeName] = useState("");
  const user = useSelector((state) => state.user);
  const [rowData, setRowData] = useState([]);
  const dispatch = useDispatch();
  const gridApiRef = useRef(null);
  const [tabIndex, setTabIndex] = useState(0);
  const currentDate = new Date();

  useEffect(() => {
    getKraData();
    getKpiData();
    refreshTable();
  }, [ department, role, year,]);
  const [open, setOpen] = useState(false);
  const [kopen, setKOpen] = useState(false);
  
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  async function getKraData(){
    try {
      const { data } = await getKraDataList(
        { role, department, year,is_kpi: false},
        user.token
      );
     
        setRowData([...data.KraList]);
      // return {
      //   rows: data.KraList,
      //   total: data.total,

      //   error: false,
      // };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } 
  }
  async function getKpiData() {
    try {
      const { data } = await getKraDataList(
        { role, department, year, is_kpi:true},
        user.token
      );

        setKpiData([...data.KraList]);
      // return {
      //   rows: data.KraList,
      //   total: data.total,

      //   error: false,
      // };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } 
  }
  console.log(rowData, "rowData");

  function Loading() {
    return (
      <div className="page d-flex">
        <div className="m-auto text-center">
          <CircularProgress />
        </div>
      </div>
    );
  }


  const onCellValueChanged = async (params) => {
    const updatedRowData = [...rowData];
    const rowIndex = params.rowIndex;
    updatedRowData[rowIndex] = params.data;
    setRowData(updatedRowData);
    // try {
    //   const { data } = await insertKraData({KRAItems:[params.data]}, user.token);
    //   setOpen(false);
    //   refreshTable();
    //   dispatch(showAlert(data.msg));
    // } catch (error) {
    //   handleAxiosError(error, dispatch);
    // }
  };
  const clearFilter = () => {
    setRole("");
    setDepartment("");
    setYear("");
  };
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    if (name === "role") setRole(value);
    else if (name === "department") setDepartment(value);
    else if (name === "year") setYear(value);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGoal((prev) => ({
      ...prev,
      [name]: value,
      role: role,
      department: department,
      year: year,
      id:"",
      is_kpi: goal?.kpi_goal?.length>0?"false":"true"
    }));
  };


  console.log(rowData,"rowdata")
  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      const { data } = await insertKraData({KRAItems:[...rowData ,...kpiData]}, user.token);
      setOpen(false);
      refreshTable();
      clearFilter();
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };


  const gridOptions = {
    defaultColDef: {
      flex: 1,
      minWidth: 100,
    },
  };

 
  const addNewRow = (status) => {
    let updatedata={
      id:"",
      role: goal.role,
      department: goal.department,
      year:goal.year === "" ?  currentDate.getFullYear().toString():goal.year,
      kpi_goal: goal.kpi_goal,
      is_kpi: status
    }
    // console.log(updatedata,"yy")
    if(status){

    }else{
      
    }
    setRowData([{...updatedata}, ...rowData]);
     setGoal( {
      id:"",
      role: "",
      department: "",
      year: "",
      is_kpi: status
      // is_kpi: "",
    })
    setOpen(false);    
  };
  const addNewKpiRow = (status) => {
    let updatedata={
      id:"",
      role: goal.role,
      department: goal.department,
      year:goal.year === "" ?  currentDate.getFullYear().toString():goal.year,
      kpi_goal: goal.kpi_goal,
      is_kpi: status
    }
    // console.log(updatedata,"yy")
    setKpiData([{...updatedata}, ...kpiData]);
     setGoal( {
      id:"",
      role: "",
      department: "",
      year: "",
      is_kpi: status
      // is_kpi: "",
    })
    setKOpen(false);    
  };
  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            KRA Goals
          </Typography>
        </Box>
      </Box>
      <br />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          boxShadow: "0 4px 6px -1px #d0d0d0",
          borderRadius: "6px",
          padding: { sm: "15px 20px", xs: "8px 8px" },
          background: "#178af4",
          color: "#101728",
          width: "100%",
        }}
      >
        <Grid
          container
          className="report-filter-box"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Role
              </InputLabel>
              <Select
                className={classes.textfeild}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={role}
                name="role"
                size="small"
                sx={{ background: "#fff" }}
                onChange={handleFilterChange}
              >
                <MenuItem value="Admin">Admin</MenuItem>
                <MenuItem value="Reporting Manager">Reporting Manager</MenuItem>
                <MenuItem value={"User"}>User</MenuItem>
                <MenuItem value={"Support"}>Support</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Department
              </InputLabel>
              <Select
                className={classes.textfeild}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={department}
                name="department"
                size="small"
                sx={{ background: "#fff" }}
                onChange={handleFilterChange}
              >
                <MenuItem value={"Development"}>Development</MenuItem>
                <MenuItem value={"Finance"}>Finance</MenuItem>
                <MenuItem value={"Hr"}>HR</MenuItem>
                <MenuItem value={"Infrastructure"}>Infrastructure</MenuItem>
                <MenuItem value={"Marketing"}>Marketing</MenuItem>
                <MenuItem value={"Sales"}>Sales</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <TextField
              name="year"
              size="small"
              fullWidth
              value={year}
              onChange={handleFilterChange}
              label="Year"
              type="text"
              // variant="outlined"
            />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={6}>
            <Button
              onClick={() => clearFilter()}
              size="medium"
              variant="contained"
              color="error"
              sx={{ fontWeight: "bold", borderRadius:"15px"  }}
            >
              Reset
            </Button>
          </Grid>
          {/* <Grid item lg={2} md={2} sm={4} xs={6}>
          </Grid> */}
        
            <Grid
              sx={{ display: "flex", justifyContent: "end" ,gap:2}}
              item
              lg={4}
              md={4}
              sm={2}
              xs={2}
            >
             {tabIndex === 0 ? (
  role !== "" && department !== "" ? (
    <Button
      size="large"
      sx={{ borderRadius: "15px" }}
      className="KRA-button"
      onClick={() => setOpen(true)}
    >
      Add New
    </Button>
  ) : null
) : (
  role !== "" && department !== "" ? (
    <Button
      size="large"
      sx={{ borderRadius: "15px" }}
      className="KRA-button"
      onClick={() => setKOpen(true)}
    >
      Add New
    </Button>
  ) : null
)}

           <Button onClick={onSubmit} size="large"
                sx={{ borderRadius: "15px" }} className="KRA-button">
            Save
           </Button>
          
            </Grid>
        </Grid>
      </Box>

      <Box sx={{ borderBottom: 1, width: "100%", borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Goals"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="KPI"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <div style={{ height: "500px" }}>
            <div style={gridStyle} className={"ag-theme-alpine"}>
              <AgGridReact
                columnDefs={[ {
                  headerName: "Goal",
                  field: "kpi_goal",
                  resizable: true,
                  wrapText: true,
                  autoHeight: true,
                  cellEditor: CustomLargeTextCellEditor,
                  cellEditorPopup: true,
                  editable: true,
                  cellEditorParams: {
                    rows: 20,
                    cols: 50,
                    // editable: true,
                  },
                },...tableDef
                ]}
                rowData={rowData}
                onCellValueChanged={onCellValueChanged}
                defaultColDef={gridOptions.defaultColDef}
              />
            </div>
          </div>
          {/* <AgGridTable
            // getTableRows={rowData}
            // columns={tableDef}
            // gridOptions={gridOptions}
            // refreshCounter={tableRefreshCount}
            // onCellValueChanged={onCellValueChanged}
          /> */}
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <Paper>
        <div style={{ height: "500px" }}>
            <div style={gridStyle} className={"ag-theme-alpine"}>
        <AgGridReact
                columnDefs={[ {
                  headerName: "KPI",
                  field: "kpi_goal",
                  resizable: true,
                  wrapText: true,
                  autoHeight: true,
                  cellEditor: CustomLargeTextCellEditor,
                  cellEditorPopup: true,
                  editable: true,
                  cellEditorParams: {
                    rows: 20,
                    cols: 50,
                    // editable: true,
                  },
                },...tableDef
                ]}
                rowData={kpiData}
                onCellValueChanged={onCellValueChanged}
                defaultColDef={gridOptions.defaultColDef}
                />
                </div>
                </div>
        </Paper>
      </TabPanel>
  
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ textTransform: "capitalize" }}
        >
          Add Goal
        </DialogTitle>
        <DialogContent>
          <Grid container minWidth={500} spacing={1} py={1}>
            <Grid item xs={12} sm={12} md={12}>
              <Grid item xs={12} md={5} sm={5}>
                <TextareaAutosize
                  className="Kratextarea"
                  name="kpi_goal"
                  onChange={handleInputChange}
                  // value={formData.goals}
                  placeholder="GOALS...."
                  type="text"
                  required
                />
              </Grid>
             
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              ml: 5,
              m: 3,
              display: "flex",
              gap: 3,
            }}
          >
            <Button onClick={() => setOpen(false)} className="cancel-button">
              Cancel
            </Button>

            <Button
                onClick={() => addNewRow(false)}
                className="add-button btn-align-right"
              >
                Add
              </Button>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={kopen}
        onClose={() => {
          setKOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ textTransform: "capitalize" }}
        >
          Add KPI
        </DialogTitle>
        <DialogContent>
          <Grid container minWidth={500} spacing={1} py={1}>
            <Grid item xs={12} sm={12} md={12}>
              <Grid item xs={12} md={5} sm={5}>
                <TextareaAutosize
                  className="Kratextarea"
                  name="kpi_goal"
                  onChange={handleInputChange}
                  // value={formData.goals}
                  placeholder="KPI...."
                  type="text"
                  required
                />
              </Grid>
             
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              ml: 5,
              m: 3,
              display: "flex",
              gap: 3,
            }}
          >
            <Button onClick={() => setKOpen(false)} className="cancel-button">
              Cancel
            </Button>

            <Button
                onClick={() => addNewKpiRow(true)}
                className="add-button btn-align-right"
              >
                Add
              </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
}



